//表单校验

export default {
  //账号
  login_name: { required: true, message: '账号不能为空' },

  //密码
  password: { required: true, message: '密码不能为空' },

  //手机号码
  mobile: (rule, value, callback) => {
    if (!value) {
      callback(new Error('手机号码必填'));
    } else {
      const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
      if (reg.test(value)) {
        callback();
      } else {
        return callback(new Error('请输入正确的手机号码'));
      }
    }
  },

  //手机验证码
  code: { required: true, message: '验证码不能为空' },
};
